/**
 * 内购收入敏感权限功能开关（来自 iap-income-permission-fs-M-7034197781 需求）。
 * 开启：产品下拉请求带 X-Menu-Code 并展示「含内购收入」标签，结果区展示无权限提示与「没有权限 / 查询失败」空状态。
 * 关闭：以上均不生效，页面保持原有展示。
 */
export const ENABLE_INCOME_PERMISSION = false
